import type { MenuPromotion } from '../model/schema';

/**
 * The "Скидки и акции" rail of the menu sidebar.
 *
 * NO API SOURCE: this is a fixed entry point to `/eats/menu/promotions`, not a
 * listing of the branch's promotions — the row is a navigation affordance from
 * the Figma design and reads the same whether or not any promotion exists.
 * Listing `PromotionService` here would make the rail appear and disappear with
 * the campaign calendar, so the section stays fixed reference data; the
 * promotions page itself is the API-backed screen.
 */
export const MENU_PROMOTIONS: readonly MenuPromotion[] = [
  // The row's own label — the SECTION is titled «Скидки и акции» (Figma
  // 1134:5086) and this single row under it reads «Все скидки» (1134:5090).
  { id: 'promo', name: 'Все скидки' },
] as const;
